import type * as Types from '../../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type LandFollowersQueryVariables = Types.Exact<{
  slug: Types.Scalars['String']['input'];
}>;

export type LandFollowersQuery = {
  __typename?: 'Query';
  landBySlug?: {
    __typename?: 'Land';
    id: string;
    slug?: string | null;
    followers?: Array<{
      __typename?: 'User';
      id: string;
      name?: string | null;
      isSmallOrganisation?: boolean | null;
      anonymised?: boolean | null;
      businessName?: string | null;
      slug?: string | null;
      surname?: string | null;
      isProGold?: boolean | null;
      role: Types.UserRole;
      sharrylandPartner: boolean;
      image?: { __typename?: 'Image'; url?: string | null; id?: string | null } | null;
      myFollow?: { __typename?: 'Follow'; id: string } | null;
    }> | null;
  } | null;
};

export const LandFollowersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'landFollowers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'landBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'followers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'image' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              alias: { kind: 'Name', value: 'id' },
                              name: { kind: 'Name', value: 'url' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'size' },
                                  value: { kind: 'StringValue', value: '160x160', block: false },
                                },
                              ],
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'myFollow' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isSmallOrganisation' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'anonymised' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'businessName' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'surname' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isProGold' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'sharrylandPartner' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class LandFollowersGQL extends Apollo.Query<LandFollowersQuery, LandFollowersQueryVariables> {
  document = LandFollowersDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
